import { useRouter } from "next/router";
import Link from "next/link";
import { Icon, Text } from "@utils/helper";
import useTranslation from "next-translate/useTranslation";
import { Fragment } from "react";
import { useSelector } from "noval";

const RenderTitle = () => {
  const { t } = useTranslation("common-locale");
  const openFundTitle = useSelector("openFundTitle");
  const {
    pathname,
    query: { fund_id },
  } = useRouter();

  const title = pathname.slice(1, pathname.length);

  const splitTitle = title.split("/");
  const zakatSearch = splitTitle.includes("zakat") && !openFundTitle;
  let accumulatedPath = "";

  if (!title.includes("/")) {
    return (
      <h1
        tabIndex={0}
        className="text-[22px] lg:text-[23px] xl:text-[34px] leading-[41px] text-[#333333] focus:outline-none"
        style={{
          fontWeight: "500",
          fontFamily: "Expo_bld",
        }}
      >
        {t(`nav.${title}`)}
      </h1>
    );
  } else {
    return (
      <ul className="flex items-center flex-wrap focus:outline-none">
        {splitTitle.map((title, index) => {
          accumulatedPath +=
            title === "[fund_id]" ? `/${fund_id}` : `/${title}`;

          const handleTitle = () => {
            if (zakatSearch) {
              return;
            }
            if (title === "[fund_id]") {
              if (openFundTitle) {
                return t(`nav.${title}`, { fund_id: openFundTitle ?? "" });
              } else {
                return t(`nav.${title}`, { fund_id });
              }
            }
            if (title === "zakat_fund_id") {
              return;
            } else {
              return t(`nav.${title}`, { fund_id: openFundTitle ?? "" });
            }
          };

          return (
            <Fragment key={index}>
              {splitTitle.length - 1 === index ? (
                <li
                  tabIndex={0}
                  className="mx-3 font-normal leading-[21px] focus:outline-none"
                >
                  <Text color="#333333" size="16px">
                    {handleTitle()}
                  </Text>
                </li>
              ) : (
                <li className="mx-3">
                  <Link
                    href={accumulatedPath}
                    style={{
                      color: zakatSearch && index === 1 ? "#333" : "#8F8F8F",
                    }}
                    className="focus:outline-none"
                  >
                    {t(`nav.${title}`, { fund_id: openFundTitle ?? "" })}
                  </Link>
                </li>
              )}
              <li
                style={{
                  display:
                    splitTitle.length - 1 === index ||
                    (zakatSearch && splitTitle.length - 2 === index)
                      ? "none"
                      : "block",
                }}
              >
                <Icon
                  height={11}
                  width={6}
                  color="#8F8F8F"
                  className="rotate-180"
                  id="Arrow"
                  viewBox="0 0 6 11"
                />
              </li>
            </Fragment>
          );
        })}
      </ul>
    );
  }
};

export default RenderTitle;
